export default __webpack_public_path__ + "static/media/banner9.3d77d9e5.jpg";